import { Spin, Typography } from 'antd';

import type { ModelMessageTemplateLite } from '@app/api/MessageTemplates';

import type { FC, MouseEvent } from 'react';

import './LeadMessageTemplatesDropdown.scss';

interface LeadMessageTemplatesDropdownProps {
  isLoading: boolean;
  isOpen: boolean;
  templates: ModelMessageTemplateLite[];
  onTemplateSelect(template: ModelMessageTemplateLite): void;
}

export const LeadMessageTemplatesDropdown: FC<
  LeadMessageTemplatesDropdownProps
> = ({ isLoading, isOpen, templates, onTemplateSelect }) => {
  if (!isOpen || (!isLoading && templates.length === 0)) return null;

  const mouseDownHandler = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  return (
    <div
      className="LeadMessageTemplatesDropdown"
      onMouseDown={mouseDownHandler}
    >
      {isLoading ? (
        <div className="LeadMessageTemplatesDropdown__loading">
          <Spin size="small" />
        </div>
      ) : (
        templates.map((template) => (
          <button
            className="LeadMessageTemplatesDropdown__item"
            key={template.Id}
            type="button"
            onClick={() => onTemplateSelect(template)}
          >
            <Typography.Text
              className="LeadMessageTemplatesDropdown__name"
              strong
              ellipsis
            >
              {template.Name || 'Без названия'}
            </Typography.Text>
            <Typography.Text
              className="LeadMessageTemplatesDropdown__message"
              type="secondary"
              ellipsis
            >
              {template.Message}
            </Typography.Text>
          </button>
        ))
      )}
    </div>
  );
};
